import { Flex, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DownloadIcon, VisibilityIcon } from 'shared/icons';
import { useJobApplicants } from '../job-applicants-provider';
import { Candidate } from '../types';

function JobApplicatCvsView({ candidate , slug }: { candidate: Candidate, slug: string }) {
   const { t } = useTranslation('global');
   const jobApplicants = useJobApplicants();

   if (candidate.jobApplyType.type === 'questionary') {
      return (
         <Flex direction="column" align="start">
            <Link to={`/candidates/applied-candidate-info/${candidate.jobApplyType.id}`}>
               <Flex width="100%" gap="2">
                  <Text color="blue" highContrast size="3" weight="medium">
                     <VisibilityIcon width={24} height={24} />
                  </Text>
                  <Text color="blue" highContrast size="3" weight="medium">
                     Переглянути
                  </Text>
               </Flex>
            </Link>
            <p style={{ fontSize: 14 }}>{t('employerInnerAccountdetail.questionnaire')}</p>
         </Flex>
      );
   }

   if (candidate.jobApplyType.type === 'cv') {
      return (
         <Flex direction="column" align="start">
            <Link
               to={`/candidates/profile/${candidate.slug}?cv_id=${candidate.cv_id}&job_apply_id=${candidate.job_apply_id}`}
            >
               <Flex width="100%" gap="2">
                  <Text color="blue" highContrast size="3" weight="medium">
                     <VisibilityIcon width={24} height={24} />
                  </Text>
                  <Text color="blue" highContrast size="3" weight="medium">
                     Переглянути
                  </Text>
               </Flex>
            </Link>
            <p style={{ fontSize: 14 }}>{t('employerInnerAccountdetail.cv')}</p>
         </Flex>
      );
   }

   if (candidate.jobApplyType.type === 'file') {
      return (
         <Flex direction="column" align="start">
            <Flex
               width="100%"
               gap="2"
               style={{ cursor: 'pointer' }}
               onClick={() => {
                  jobApplicants.loadPdf(
                     {
                        id: candidate.jobApplyType.id,
                        filename: `${candidate.name}-cv`,
                     },
                     {
                        onSuccess: () => {
                           if(candidate.apply_status === 'new') {
                                jobApplicants.onStatusChange({
                                   candidateId: candidate.job_apply_id,
                                   userId: candidate.user_id,
                                   status: 'reviewed',
                                   slug: slug,
                                });
                           }
                        },
                     }
                  );
               }}
            >
               <Text color="blue" highContrast size="3" weight="medium">
                  <DownloadIcon width={24} height={24} />
               </Text>
               <Text color="blue" highContrast size="3" weight="medium">
                  {t('employerInnerAccountdetail.download')}
               </Text>
            </Flex>
            <p style={{ fontSize: 14 }}>{t('employerInnerAccountdetail.file')}</p>
         </Flex>
      );
   }

   return null;
}

export const JobApplicatCvs = observer(JobApplicatCvsView);
